import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {UserPermissionModel } from '../models/classes/permission';

@Injectable({
  providedIn: 'root',
})

export class UserpermissionService {
  ip = environment.ipServer;
  constructor(private http: HttpClient) {}

  getPermission(userId: number) {
    const url = `${this.ip}/api/UserPermission/GetUserPermission/${userId}`;
    return this.http.get<UserPermissionModel[]>(url).pipe(tap((data) => data));
  }
  updateUserPermission(id: number, permission: UserPermissionModel){
    const url = `${this.ip}/api/UserPermission/${id}`;
    return this.http.put(url, permission);
  }
}
